import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-settings-promotion',
  templateUrl: './settings-promotion.component.html',
  styleUrls: ['./settings-promotion.component.scss']
})
export class SettingsPromotionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
